import { render, staticRenderFns } from "./ruleConfiguration.vue?vue&type=template&id=f98d119e&scoped=true&"
import script from "./ruleConfiguration.vue?vue&type=script&lang=js&"
export * from "./ruleConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ruleConfiguration.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ruleConfiguration.vue?vue&type=style&index=1&id=f98d119e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98d119e",
  null
  
)

export default component.exports